module.exports = __webpack_public_path__ + "img/already.a1b1a6f0.png";